/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import BackgroundImage from '../components/BackgroundImage';
import ContactForm from '../components/ContactForm';
import ContentGroup from '../components/ContentGroup';
import ContentGroupGrid from '../components/ContentGroupGrid';
import CustomFormView from '../components/CustomFormView';
import DetailHero from '../components/DetailHero';
import DualImage from '../components/DualImage';
import ETILogo from '../components/ETILogo';
import FourColumnAdjustableContainer from '../components/FourColumnAdjustableContainer';
import GenericForm from '../components/GenericForm';
import Icon from '../components/Icon';
import ImageTextBlock from '../components/ImageTextBlock';
import Input from '../components/Input';
import LinkTable from '../components/LinkTable';
import MediaHero from '../components/MediaHero';
import MobileMenuIcon from '../components/MobileMenuIcon';
import Modal from '../components/Modal';
import NavMainLink from '../components/NavMainLink';
import NotificationBlock from '../components/NotificationBlock';
import ResourceBlock from '../components/ResourceBlock';
import RouteLink from '../components/RouteLink';
import ScrollTop from '../components/ScrollTop';
import SectorHero from '../components/SectorHero';
import SectorIcon from '../components/SectorIcon';
import SectorItem from '../components/SectorItem';
import SectorPanels from '../components/SectorPanels';
import SignUpBlock from '../components/SignUpBlock';
import SiteFooter from '../components/SiteFooter';
import SiteHeader from '../components/SiteHeader';
import Tag from '../components/Tag';
import Textarea from '../components/Textarea';
import TextBlock from '../components/TextBlock';
import ThreeColumnAdjustableContainer from '../components/ThreeColumnAdjustableContainer';
import ThreeUp from '../components/ThreeUp';
import TransLink from '../components/TransLink';
import TwoColumnAdjustableContainer from '../components/TwoColumnAdjustableContainer';
import VimeoEmbed from '../components/VimeoEmbed';

const components = new Map();
components.set('BackgroundImage', BackgroundImage);
components.set('ContactForm', ContactForm);
components.set('ContentGroup', ContentGroup);
components.set('ContentGroupGrid', ContentGroupGrid);
components.set('CustomFormView', CustomFormView);
components.set('DetailHero', DetailHero);
components.set('DualImage', DualImage);
components.set('ETILogo', ETILogo);
components.set('FourColumnAdjustableContainer', FourColumnAdjustableContainer);
components.set('GenericForm', GenericForm);
components.set('Icon', Icon);
components.set('ImageTextBlock', ImageTextBlock);
components.set('Input', Input);
components.set('LinkTable', LinkTable);
components.set('MediaHero', MediaHero);
components.set('MobileMenuIcon', MobileMenuIcon);
components.set('Modal', Modal);
components.set('NavMainLink', NavMainLink);
components.set('NotificationBlock', NotificationBlock);
components.set('ResourceBlock', ResourceBlock);
components.set('RouteLink', RouteLink);
components.set('ScrollTop', ScrollTop);
components.set('SectorHero', SectorHero);
components.set('SectorIcon', SectorIcon);
components.set('SectorItem', SectorItem);
components.set('SectorPanels', SectorPanels);
components.set('SignUpBlock', SignUpBlock);
components.set('SiteFooter', SiteFooter);
components.set('SiteHeader', SiteHeader);
components.set('Tag', Tag);
components.set('Textarea', Textarea);
components.set('TextBlock', TextBlock);
components.set('ThreeColumnAdjustableContainer', ThreeColumnAdjustableContainer);
components.set('ThreeUp', ThreeUp);
components.set('TransLink', TransLink);
components.set('TwoColumnAdjustableContainer', TwoColumnAdjustableContainer);
components.set('VimeoEmbed', VimeoEmbed);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
